<template>
  <div style="height: 100%">
    <div class="sa-flexbox" style="padding-bottom: 20px">
      <div class="sa-flexbox-body">
        <div class="d-flex flex-column">
          <b-row
            class="sa-label-info"
            style="margin-left: 0.5rem; margin-right: 0.5rem"
          >
            <b-col lg="3">
              <p>Records Totali: {{ rows }}</p>
            </b-col>
            <b-col lg="9">
              <b-pagination
                :total-rows="rows"
                v-model="page"
                :per-page="perPage"
                align="right"
                size="sm"
              >
              </b-pagination>
            </b-col>
          </b-row>
        </div>
        <div class="b-table-sticky-header">
          <b-table
            sticky-header
            ref="table"
            stacked="lg"
            striped
            hover
            :items="items"
            :fields="fields"
            :current-page="1"
            :per-page="perPage"
            :key="listKey"
            sort-icon-left
            head-variant="light"
            class="sa-b-table"
          >
                   <template #cell(tipologia)="row">
              
               <div v-if="row.item.ricette.length == 1">  <strong> {{ row.item.ricette[0].tipologiaRicetta }} </strong></div>
                            <div v-else>
                                <strong v-for="ricetta in row.item.ricette" :key="ricetta">
                                    {{ ricetta.tipologiaRicetta }} - 
                                </strong>
                            </div> 
            </template> 
            <template #cell(nre)="row">
              
               <div v-if="row.item.ricette.length == 1">  {{ row.item.ricette[0].codiceBar1 }}{{  row.item.ricette[0].codiceBar2 }} </div>
                            <div v-else>
                                <strong v-for="ricetta in row.item.ricette" :key="ricetta">
                                    {{ ricetta.codiceBar1 }}{{ ricetta.codiceBar2 }}  - 
                                </strong>
                            </div> 
            </template> 

            <template #cell(assistito)="row">
              {{ row.item.accettazione.accettazioneAnagrafica.identificativo }}
            </template>
            <template #cell(actions)="{ item }">
               <b-button
                size="sm"
                class="mr-1 ml-1 no-text"
                variant="outline-secondary"
                @click="onClickOpenDetailAccettazione(item)"
              >
                <i class="bi bi-eye"></i>
              </b-button> 
              <!-- @click="onPrintPreview(row.item)" -->
              <b-button
                size="sm"
                variant="btn btn-purple waves-effect  waves-light width-sm no-text"
                @click="onClickAnteprimaStampa(item)"
                style="margin-right: 3px"
              >
                <b-icon icon="printer"></b-icon>
              </b-button>
              <print-component
                :jsonData="item"
                :linkPrintData="linkPrintData(item)"
                typeButton="small"
                :firmaGrafometrica="true"
              ></print-component>
            </template>
          </b-table>
        </div>
      </div>
      <div class="d-flex flex-column">
        <b-row
          class="sa-label-info"
          style="margin-left: 0.5rem; margin-right: 0.5rem"
        >
          <b-col lg="3">
            <p>Records Totali: {{ rows }}</p>
          </b-col>
          <b-col lg="9">
            <b-pagination
              :total-rows="rows"
              v-model="page"
              :per-page="perPage"
              align="right"
              size="sm"
            >
            </b-pagination>
          </b-col>
        </b-row>
      </div>
      <pdf-print-view-embedded
        ref="pdfPrintViewEmbedded"
        :pdf="signedPdfViewer"
      ></pdf-print-view-embedded>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import PrintComponent from "../../../utility/components/PdfPrintViewEmbedded.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import PdfPrintViewEmbedded from "../../../utility/components/PdfPrintViewEmbedded.vue";
import PrintComponent from "../../../utility/components/PrintComponent.vue";

export default {
  components: { PdfPrintViewEmbedded, PrintComponent },
  data() {
    return {
      pathResource: "/accettazionessn",
      items: null,
      rows: 0,
      perPage: 10,
      filtro: {
        page: 1,
        forPage: 20,
        codiceFiscaleAssistito: null,
      },
      page: 1,
      signedPdfViewer: null,
      listKey: 0,
      previewSelected: null,
      fields: [
           {
          label: "Tipo Ricetta",
          key: "tipologia",
        },
        {
          label: "NRE",
          key: "nre",
        },
        {
          label: "C.F Assistito",
          key: "assistito",
        },

        {
          label: "data creazione",
          key: "createDate",
          formatter: (param) => {
            return UtilityMixin.methods.formatDateTime(param);
          },
        },
        {
          label: "",
          class: "sa-table-column-action-double",
          key: "actions",
        },
      ],
    };
  },
  mixins: { UtilityMixin },
  mounted() {
    let me = this;
    me.init();
  },
  methods: {
    init() {
      let me = this;
      me.loadData();
    },
    loadData() {
      let me = this;
      me.$emit("beforeLoadData");
      me.items = [];
      let filtroStr = sessionStorage.getItem("filtroPageAccettazioneSsn");
      let filtroJson = JSON.parse(filtroStr);
      me.filtro = filtroJson;
      UtilityMixin.methods.loadDataResources(
        me.pathResource,
        me.filtro,
        me.loadDataAccettazioneSsnSuccess,
        me.loadDataAccettazioneSsnError
      );
    },

    loadDataAccettazioneSsnSuccess(response) {
      let me = this;
      me.items = response.data.data.list;
      me.rows = response.data.data.recordsNumber;
      me.listKey++;
      me.$emit("afterLoadData");
    },
    loadDataAccettazioneSsnError(response) {
      let me = this;
      me.$emit("afterLoadData", response);
      me.$bvToast.toast("Errore durante il caricamento", {
        title: "Errore",
        variant: "danger",
        solid: true,
      });
    },
    linkPrintData(item) {
      let returnValue = "/printer/" + item.id;
      return returnValue;
    },
    onClickOpenDetailAccettazione(accettazione) {
     this.$router.push("accettazionessn/"+accettazione.id)
    },
    onClickAnteprimaStampa(item) {
      let me = this;
      let prestazioni = null;
      let identificativo =
        item.accettazione.accettazioneAnagrafica.identificativo;
      if (item.ricette.length >= 1) {
        prestazioni = item.ricette[0].prestazioni;
      } else {
        //TODO
      }
      let print = {
        reportName: "RegistroPresenze",
        data: {
          identificativo: identificativo,
          prestazioni: prestazioni,
        },
      };
      me.onPrintPreview(print);
    },
    onClickAnnulla() {
      let me = this;
      me.$refs.mdlPreviewStampa.hide();
    },
    onPrintPreview(item) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + "/print/createreport";
      me.showModalLoading = true;
      axios
        .post(link, item)
        .then((response) => {
          me.signedPdfViewer =
            "data:application/pdf;base64," + response.data.base64;

          me.$refs.pdfPrintViewEmbedded.show();
        })
        .catch((error) => {
          // me.$refs.mdlGenerazioneReportInCorso.hide();
          me.showModalLoading = false;
          let messaggio = error.response.data.messaggio
            ? error.response.data.messaggio
            : "Errore non gestito, Codice: " + error.response.status;
          this.$bvModal
            .msgBoxOk(messaggio, {
              title: this.$i18n.t("ERROR!"),
              size: "sm",
              okVariant: "outline-danger",
              headerClass: "sa-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then((value) => {
              this.boxTwo = value;
            })
            .catch((err) => {
              err;
            });
        });
    },


    onOpenView(){
      
    }
  },
  watch: {
    page() {
      let me = this;
      me.loadData();
    },
  },
};
</script>

<style></style>
